import { useState } from "react";
import ClubAuthModal from "./ClubAuthModal";
import UserContentModal from "./UserContentModal";
import "./style.scss";

export function FreeCustomerClub() {
    const [content, setContent] = useState();

    const verificationHandle = (content) => {
        setContent(content);
    };

    return (
        <div className="share-gate">
            {!content && (
                <ClubAuthModal show={true} verified={verificationHandle} />
            )}
            {content && <UserContentModal show={content.content} />}
        </div>
    );
}
